<template>
  <div>
    <el-row class="querypanel">
      <el-col :span="12">
        <el-form ref="form"  label-width="120px" label-position="left">
          <el-form-item label="上课时间">
            <el-select v-model="weekinfo" clearable placeholder="按上课日期查询" >
              <el-option
                v-for="item in weeklist"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-form ref="form"  label-width="120px" label-position="left">
          <el-form-item label="会员联系方式">
            <el-input  v-model="ed_userphone" placeholder="请输入用户的联系方式用户"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <div>
          <el-button style="margin-top: 10px; margin-left: 10px;" @click="querymember">查询会员</el-button>
          <el-button style="margin-top: 10px; margin-left: 10px;" @click="sendmsg">发送信息</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="querypanel">
      <el-table
        stripe
        :data="memberdata"
        @selection-change="member_sel">
        ref="ref_memberdata">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="openid"
          width = "200px"
          label="OpenID">
        </el-table-column>
        <el-table-column
          prop="usernick.String"
          width = "200px"
          label="会员昵称">
        </el-table-column>
        <el-table-column
          label="头像">
          <template slot-scope="scope">
            <div v-if="scope.row.userimg.Valid && scope.row.userimg.String !== ''">
              <img :src="scope.row.userimg.String" class="avatarimg">
            </div>
            <div v-else>
              {{scope.row.imgurl.String}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone.String"
          label="电话号码">
        </el-table-column>
        <el-table-column
          prop="name.String"
          label="姓名">
        </el-table-column>
        <el-table-column
          label="操作"
          width="120px"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="发送消息" placement="top-start">
              <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="sendmsginfo(scope.$index, memberdata)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-dialog title="消息" :visible.sync="vis_mm_edit">
      <el-tabs v-model="qdtab">
        <el-tab-pane label="课前提醒" name="kqtx">
          <el-form ref="form"  label-width="100px" label-position="left" >
            <el-form-item label="标题">
              <el-input  v-model="kq_title" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="课程名称">
              <el-input  v-model="kq_name" placeholder="请输入课程名称"></el-input>
            </el-form-item>
            <el-form-item label="课程时间">
              <el-input  v-model="kq_time" placeholder="请输入上课时间"></el-input>
            </el-form-item>
            <el-form-item label="课程地点">
              <el-input  v-model="kq_pos" placeholder="请输入上课地点"></el-input>
            </el-form-item>
            <el-form-item label="课前提醒">
              <el-input  v-model="kq_des" placeholder="请输入课前提醒内容"></el-input>
            </el-form-item>
            <el-button class="gibasebtn" @click="send_kqtx">保存消息模板</el-button>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="课次提醒" name="kctx">
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'MemberMsg',
  data () {
    return {
      qdtab: 'kqtx',
      memberdata: [],
      kq_title: '课前提醒',
      kq_name: '机器人培训课',
      kq_time: '',
      kq_pos: '我们新教区',
      kq_des: '马上就上课了，别忘了呦',
      bymemberdate: '',
      ed_userphone: '',
      vis_mm_edit: false,
      weeklist: [{
        value: '1',
        label: '星期一'
      }, {
        value: '2',
        label: '星期二'
      }, {
        value: '3',
        label: '星期三'
      }, {
        value: '4',
        label: '星期四'
      }, {
        value: '5',
        label: '星期五'
      }, {
        value: '6',
        label: '星期六'
      }, {
        value: '7',
        label: '星期日'
      }],
      weekinfo: '',
      classmember: [],
      sel_openids: []
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    console.log(that)
    if (getCookie('accesstoken') === '' || getCookie('accesstoken') === null) {
      that.$options.methods.getaccesstoken()
    } else {
    }
  },
  methods: {
    getaccesstoken: function () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/wx/getaccesstoken',
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            setCookie('accesstoken', res.data.data, 7200)
            // 把相关数据缓存到本地
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    member_sel (rows) {
      that.sel_openids = []
      if (rows) {
        rows.forEach(row => {
          that.sel_openids.push(row.openid)
        })
      } else {
        this.$refs.ref_memberdata.clearSelection()
      }
    },
    querymember () {
      if (that.ed_userphone !== null && that.ed_userphone !== '') {
        var qstr = ' openid is not null'
        qstr = qstr + " and phone like '%" + that.ed_userphone + "%' "
        that.$http({
          url: 'https://api.sqnetsoft.cn/member/gbuw',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              console.log(JSON.parse(res.data.data))
              that.memberdata = JSON.parse(res.data.data)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
      if (that.weekinfo !== null && that.weekinfo !== '') {
        var wstr = ' weekid = ' + that.weekinfo
        that.$http({
          url: 'https://api.sqnetsoft.cn/class/qbcs',
          method: 'post',
          data: {
            whereinfo: {String: wstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              console.log(JSON.parse(res.data.data))
              var tmpclassmember = JSON.parse(res.data.data)
              that.classmember = []
              for (var i = 0; i < tmpclassmember.length; i++) {
                that.classmember.push("'" + tmpclassmember[i].userphone + "'")
              }
              var cstr = 'phone in (' + that.classmember + ')'
              that.$http({
                url: 'https://api.sqnetsoft.cn/member/gbuw',
                method: 'post',
                data: {
                  whereinfo: {String: cstr, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    console.log(JSON.parse(res.data.data))
                    that.memberdata = JSON.parse(res.data.data)
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    sendmsginfo (index, data) {
      window.console.log(data[index])
      console.log(this.$refs.ref_memberdata.toggleAllSelection())
      /*
      that.$http({
        url: 'https://api.sqnetsoft.cn/wx/sgtm',
        method: 'post',
        data: {
          accesstoken: getCookie('accesstoken'),
          touser: data[index].openid,
          tempid: '9C3-TUxhaqNCGMaHl4k-Di95cuCp9vp7F-KUDuwYT4I',
          url: 'http://www.baidu.com',
          data: {
            keyword1: {value: 'XXX课程'},
            keyword2: {value: '2019.12.19'},
            keyword3: {value: '我们新教区'}
          },
          color: '#000000'
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            // 把相关数据缓存到本地
            window.console.log(res.data.data)
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
       */
    },
    sendmsg () {
      console.log(that.sel_openids)
      that.vis_mm_edit = true
      that.kq_time = getNowFormatDate()
    },
    send_kqtx () {
      var requestlist = []
      for (var i = 0; i < that.sel_openids.length; i++) {
        var request = that.$http({
          url: 'https://api.sqnetsoft.cn/wx/sgtm',
          method: 'post',
          data: {
            accesstoken: getCookie('accesstoken'),
            touser: that.sel_openids[i],
            tempid: 'UFEnvZPBYP19EoXC9EhIOJgPKctH_R1JDRbGQRsldNM',
            url: 'http://www.baidu.com?openid=' + that.sel_openids[i],
            data: {
              first: {value: that.kq_title, color: '#FF0000'},
              keyword1: {value: that.kq_name},
              keyword2: {value: that.kq_time},
              keyword3: {value: that.kq_pos},
              remark: {value: that.kq_des}
            },
            color: '#000000'
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              // 把相关数据缓存到本地
              window.console.log(res.data.data)
            }
          })
          .catch(function (error) {
            window.console.log(error)
          })
        requestlist.push(request)
      }
      console.log(requestlist)
      axios.all(requestlist)
    },
    save_tmpmsg () {}
  }
}
function setCookie (name, value, seconds) {
  var d = new Date()
  d.setTime(d.getTime() + 1000 * seconds)
  window.document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString()
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
function getNowFormatDate () {
  var date = new Date()
  var seperator1 = '-'
  var month = date.getMonth() + 1
  var strDate = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  var hours = date.getHours()
  if (hours >= 0 && hours <= 9) {
    hours = '0' + hours
  }
  var minutes = date.getMinutes()
  if (minutes >= 0 && minutes <= 9) {
    minutes = '0' + minutes
  }
  var seconds = date.getSeconds()
  if (seconds >= 0 && seconds <= 9) {
    seconds = '0' + seconds
  }
  var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
  return currentdate
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/message/MemberMsg.vue